import { render } from "./ConfigurationsAdresses.vue?vue&type=template&id=3975af54"
import script from "./ConfigurationsAdresses.vue?vue&type=script&lang=js"
export * from "./ConfigurationsAdresses.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__